var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticStyle:{"cursor":"pointer"},attrs:{"src":_vm.modalImgSrc},on:{"click":_vm.modalClick}}),_c('p',{staticClass:"grey--text text--lighten-1"},[_vm._v("※画像をクリックすると拡大します")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }